import React from 'react';

import { Alert, Container } from './components/Common';

export default ({ withSidebar = false }) => {
	if (withSidebar)
		return (
			<Container first tabs>
				<div className="p20">
					<Alert title="Error" error>
						Something went wrong.
						<br />
						Try refreshing the page or try again later.
					</Alert>
				</div>
			</Container>
		);

	return (
		<div className="p20">
			<Alert title="Error" error>
				Something went wrong.
				<br />
				Try refreshing the page or try again later.
			</Alert>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/Error.js